
import Vue from "vue";
import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
import { Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Experience extends Vue {
  activeName: string = '投建营-OP';
  tabSystemConfigList: Array<{ [key: string]: any }> = [];

  @Getter productEvns: any;
  @Action("getAllProductEvn") getAllProductEvn: Function;

  created() {
    this.getAllProductEvn({onlyEnabled: true});
  }

  @Watch('productEvns', { deep: true })
  @Watch('activeName')
  handleTabSystemConfigList() {
    const { infos } = this.productEvns as any;
    if (Array.isArray(infos)) {
      const filterValue = infos.filter(
        (item: any) => item.Title === this.activeName
      ).flatMap((item: any) => item.children);
      this.tabSystemConfigList = (filterValue && filterValue) || [];
    } else {
      this.tabSystemConfigList = [];
    }
  }

  robot() {
    const user = JSON.parse(localStorage.logonUser);

    const url =
      "https://robotapi.fdcyun.com/?channel=corp&redirect=/&biz_id=CORP-XIAOSHOU&version=CORP-XIAOSHOU&userguid=" +
      user.UserGUID +
      "&phone=" +
      user.MobilePhone +
      "&email=" +
      user.Email +
      "&username=" +
      user.UserName +
      "&openid=" +
      user.UserCode +
      "";
    window.open(url);
    //window.open('https://mingyuanyun.faqrobot.cn/robot/chat2.html?jid=55&amp;sysNum=1476067342641247&amp;sourceId=2972');
  }

  deploy(Title: string) {
    this.$router.push({ path: `/documents/${Title}` });
  }

  experience(url: string) {
    window.open(url);
  }
}
